class CategoryModel {
    id?: number;
    categoryId:number;
    code?: string;
    name?: string;
    shortName?:string;
    displayOrder?: number;
    financeCode?: string;
    isActive?: boolean;
    isAllowCredit?: boolean;
    isSpecialOrder?: boolean;
    isCommission?: boolean
}
export default CategoryModel;



